import { Path, Svg } from "react-native-svg"

export const ApprovalComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#333"
            d="M752 152A120 120 0 0 0 632 32H152A120 120 0 0 0 32 152v720a120 120 0 0 0 120 120h173.4L752 242zM312.2 792.2h-80.4a40.2 40.2 0 1 1 0-79.8h80.4a40.2 40.2 0 1 1 0 79.8zm40.2-240h-120a40.2 40.2 0 0 1 0-79.8h120a40.2 40.2 0 0 1 0 79.8zm199.8-240H231.8a40.2 40.2 0 1 1 0-79.8h320.4a40.2 40.2 0 0 1 0 79.8zM971.6 272l-34.8-19.8a40.2 40.2 0 0 0-54.6 15L585.8 788.6l104.4 60L986.6 326a40.2 40.2 0 0 0-15-54zM539 992l131.4-109.2L566 823.4 539 992z"
        />
    </Svg>
)

export const ApprovalRulesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#333"
            d="M222 887.9c-46.3 0-84-37.7-84-84v-580c0-46.3 37.7-84 84-84h580c46.3 0 84 37.7 84 84v580c0 46.3-37.7 84-84 84H222zm4.6-226.9c-26.5 0-48 21.5-48 48s21.5 48 48 48h574.3c26.5 0 48-21.5 48-48s-21.5-48-48-48H226.6zm135.8-108.8c.8 0 1.7.2 2.4.6l72.1 37.9c5.5 2.9 11.3 4.3 17.3 4.3 11 0 21.4-4.9 28.6-13.4 7-8.4 10-19.4 8.2-30.2l-13.8-80.3c-.3-1.7.3-3.4 1.5-4.7l58.3-56.8c10.2-10 13.8-24.6 9.4-38.2-4.4-13.6-15.9-23.3-30.1-25.4l-80.6-11.7c-1.7-.2-3.2-1.3-4-2.9l-36-73c-6.3-12.8-19.1-20.8-33.4-20.8s-27.1 8-33.4 20.8l-36 73c-.8 1.6-2.2 2.6-4 2.9L208.3 346c-14.1 2.1-25.7 11.8-30.1 25.4-4.4 13.6-.8 28.2 9.4 38.2l58.3 56.8c1.2 1.2 1.8 3 1.5 4.7l-13.8 80.3c-1.9 10.9 1.1 21.9 8.2 30.2 7.2 8.5 17.6 13.4 28.6 13.4 6 0 11.9-1.5 17.3-4.3l72.1-37.9c.9-.4 1.7-.6 2.6-.6zm259.2-85.7c-26.5 0-48 21.5-48 48s21.5 48 48 48h179.3c26.5 0 48-21.5 48-48s-21.5-48-48-48H621.6zm0-194.5c-26.5 0-48 21.5-48 48s21.5 48 48 48h179.3c26.5 0 48-21.5 48-48s-21.5-48-48-48H621.6z"
        />
        <Path
            fill="#333"
            d="M802 155.9c37.5 0 68 30.5 68 68v580c0 37.5-30.5 68-68 68H222c-37.5 0-68-30.5-68-68v-580c0-37.5 30.5-68 68-68h580M281.1 319.4l-75 10.9c-20.2 2.9-36.7 16.8-43 36.3-6.3 19.4-1.1 40.3 13.5 54.6l54.3 52.9-12.9 74.7c-2.7 15.5 1.6 31.3 11.7 43.3 10.2 12.1 25.1 19.1 40.8 19.1 8.5 0 17.1-2.1 24.8-6.2l67.1-35.3 67.1 35.3c7.7 4 16.2 6.2 24.8 6.2 15.7 0 30.6-6.9 40.8-19.1 10.1-12 14.4-27.7 11.7-43.3L494 474.1l54.3-52.9c14.6-14.3 19.8-35.2 13.5-54.6-6.3-19.4-22.8-33.3-43-36.3l-75-10.9-33.5-68c-9-18.3-27.3-29.7-47.8-29.7-20.4 0-38.7 11.4-47.8 29.7l-33.6 68M621.6 384h179.3c35.3 0 64-28.7 64-64s-28.7-64-64-64H621.6c-35.3 0-64 28.7-64 64s28.7 64 64 64m0 194.5h179.3c35.3 0 64-28.7 64-64s-28.7-64-64-64H621.6c-35.3 0-64 28.7-64 64s28.7 64 64 64M226.6 773h574.3c35.3 0 64-28.7 64-64s-28.7-64-64-64H226.6c-35.3 0-64 28.7-64 64s28.8 64 64 64M802 123.9H222c-55.2 0-100 44.8-100 100v580c0 55.2 44.8 100 100 100h580c55.2 0 100-44.8 100-100v-580c0-55.3-44.8-100-100-100zM270.5 579.1c-12.4 0-23.3-11.2-21-24.9l13.8-80.3c1.2-6.9-1.1-13.9-6.1-18.8l-58.3-56.8c-12.6-12.3-5.7-33.7 11.8-36.3l80.6-11.7c6.9-1 12.9-5.4 16-11.6l36-73c3.9-7.9 11.5-11.9 19.1-11.9 7.6 0 15.2 4 19.1 11.9l36 73c3.1 6.3 9.1 10.6 16 11.6l80.6 11.7c17.4 2.5 24.4 24 11.8 36.3l-58.3 56.8c-5 4.9-7.3 11.9-6.1 18.8l13.8 80.3c2.4 13.7-8.6 24.9-21 24.9-3.3 0-6.6-.8-9.9-2.5l-72.1-37.9c-3.1-1.6-6.5-2.4-9.9-2.4s-6.8.8-9.9 2.4l-72.1 37.9c-3.3 1.7-6.6 2.5-9.9 2.5zM621.6 352c-17.7 0-32-14.3-32-32s14.3-32 32-32h179.3c17.7 0 32 14.3 32 32s-14.3 32-32 32H621.6zm0 194.5c-17.7 0-32-14.3-32-32s14.3-32 32-32h179.3c17.7 0 32 14.3 32 32s-14.3 32-32 32H621.6zM226.6 741c-17.7 0-32-14.3-32-32s14.3-32 32-32h574.3c17.7 0 32 14.3 32 32s-14.3 32-32 32H226.6z"
        />
    </Svg>
)

export const ApprovalWorkflowComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M800.047 286.72h105.814c34.133 0 61.819-27.686 61.819-61.82V119.088c0-34.133-27.686-62.198-61.82-62.198H800.048c-34.133 0-61.819 28.065-61.819 62.198v14.83h-92.805a37.926 37.926 0 0 0-37.926 37.925v302.346H551.86c-18.356-119.391-121.628-211.361-246.367-211.361C168.201 262.827 56.32 374.708 56.32 512c0 137.671 111.881 249.553 249.173 249.553 124.7 0 227.935-91.895 246.33-211.513h55.674v302.345a37.926 37.926 0 0 0 37.926 37.926h92.805v14.98c0 34.134 27.686 61.82 61.82 61.82H905.86c34.133 0 61.819-27.686 61.819-61.82V799.48c0-34.134-27.686-61.82-61.82-61.82H800.048c-34.133 0-61.819 27.686-61.819 61.82v14.98H683.35V550.04h54.88v15.057c0 34.134 27.685 61.82 61.818 61.82h105.814c34.133 0 61.819-27.686 61.819-61.82V459.283c0-34.133-27.686-62.199-61.82-62.199H800.048c-34.133 0-61.819 28.066-61.819 62.199v14.905H683.35V209.73h54.88v15.133c0 34.133 27.685 61.82 61.818 61.82z" />
    </Svg>
)

export const EmployeesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M85.344 938.656c0-188.512 152.832-341.344 341.344-341.344s341.344 152.832 341.344 341.344H85.376zm341.312-384c-141.44 0-256-114.56-256-256s114.56-256 256-256 256 114.56 256 256-114.56 256-256 256zm314.176 95.296c132.416 34.88 230.144 149.152 239.744 287.712l.064.992H853.376c0-111.36-42.656-212.736-112.512-288.736zm-86.336-97.12A339.84 339.84 0 0 0 768 299.04V298.112c0-60.992-16.064-118.208-44.192-167.68l.864 1.696c98.4 20.288 171.296 106.208 171.296 209.152v.128a213.28 213.28 0 0 1-242.592 211.296l1.12.128z" />
    </Svg>
)


export const ShiftsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#212121"
            d="M277.333 512a234.667 234.667 0 1 1 0 469.333 234.667 234.667 0 0 1 0-469.333zm480-384A138.667 138.667 0 0 1 896 266.667v490.666A138.667 138.667 0 0 1 757.333 896l-246.314.043a276.053 276.053 0 0 0 43.648-149.376c0-64.64-22.144-124.16-59.307-171.222l2.987.427 2.986.128h191.915l4.352-.299a32 32 0 0 0 0-63.402l-4.352-.299H533.333V288l-.298-4.352a32 32 0 0 0-63.403 0l-.299 4.352v256l.214 2.73a276.395 276.395 0 0 0-192.214-77.397 276.053 276.053 0 0 0-149.376 43.648L128 266.667A138.667 138.667 0 0 1 266.667 128h490.666zm-480 618.667h-128a21.333 21.333 0 0 0-20.992 17.493L128 768v21.163c0 42.41 32.299 63.914 85.333 63.914 50.39 0 82.048-19.37 85.078-57.685l.256-6.187V768a21.333 21.333 0 0 0-21.334-21.333zm128.854-.598-68.694-.042a65.81 65.81 0 0 1 3.584 16.213l.256 5.76v21.205l-.298 9.046c-.854 11.776-3.243 22.528-7.168 32.213 5.717.597 11.776.853 18.133.853 43.776 0 72.235-13.653 75.264-44.16l.256-5.546v-14.208a21.333 21.333 0 0 0-17.493-20.992l-3.84-.342zM213.333 618.667a42.752 42.752 0 1 0 0 85.461 42.752 42.752 0 0 0 0-85.461zm133.547 10.965a37.248 37.248 0 1 0 0 74.539 37.248 37.248 0 0 0 0-74.539z"
        />
    </Svg>
)

export const AttendanceComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M712.533 418.133c-14.933-17.066-40.533-17.066-57.6-4.266L652.8 416 469.333 595.2l-76.8-74.667-2.133-2.133c-17.067-12.8-42.667-12.8-57.6 4.267-14.933 17.066-14.933 40.533-2.133 57.6l2.133 2.133 106.667 102.4 2.133 2.133c14.933 12.8 38.4 12.8 53.333 0l2.134-2.133L710.4 480l2.133-2.133c17.067-19.2 17.067-42.667 0-59.734zM704 85.333c23.467 0 42.667 19.2 42.667 42.667v42.667H832c70.4 0 128 57.6 128 128v512c0 70.4-57.6 128-128 128H192c-70.4 0-128-57.6-128-128v-512c0-70.4 57.6-128 128-128h85.333V128c0-23.467 19.2-42.667 42.667-42.667s42.667 19.2 42.667 42.667v42.667h298.666V128c0-23.467 19.2-42.667 42.667-42.667z" />
    </Svg>
)

export const AttendanceByDateComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#4B4B4B"
            d="M992 416v448a96 96 0 0 1-96 96H128a96 96 0 0 1-96-96V416h960zM160 128v48a80 80 0 0 0 74.752 79.84L240 256h32a80 80 0 0 0 79.84-74.752L352 176v-48h320v48a80 80 0 0 0 74.752 79.84L752 256h32a80 80 0 0 0 79.84-74.752L864 176v-48h32a96 96 0 0 1 96 96v128H32V224a96 96 0 0 1 96-96h32zm96-64a48 48 0 0 1 48 48v64a48 48 0 0 1-96 0v-64a48 48 0 0 1 48-48zm512 0a48 48 0 0 1 48 48v64a48 48 0 0 1-96 0v-64a48 48 0 0 1 48-48z"
        />
    </Svg>
)

export const AttendaneceByEmployeesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M85.344 938.656c0-188.512 152.832-341.344 341.344-341.344s341.344 152.832 341.344 341.344H85.376zm341.312-384c-141.44 0-256-114.56-256-256s114.56-256 256-256 256 114.56 256 256-114.56 256-256 256zm314.176 95.296c132.416 34.88 230.144 149.152 239.744 287.712l.064.992H853.376c0-111.36-42.656-212.736-112.512-288.736zm-86.336-97.12A339.84 339.84 0 0 0 768 299.04V298.112c0-60.992-16.064-118.208-44.192-167.68l.864 1.696c98.4 20.288 171.296 106.208 171.296 209.152v.128a213.28 213.28 0 0 1-242.592 211.296l1.12.128z" />
    </Svg>
)


export const FinanceComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M688 512q-48 .992-79.488 32.512T576 624q.992 48 32.512 79.488T688 736h208v160H128V352h768v160H688zm32 160h-32q-20-.992-33.504-14.496T640.992 624t13.504-33.504T688 576h32q20 .992 33.504 14.496T767.008 624t-13.504 33.504T720 672zm-80-544 128 160H384z" />
    </Svg>
)


export const MoneyTrasnferComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M768 597.333A42.667 42.667 0 0 1 768 512h85.333a42.667 42.667 0 0 1 0 85.333H768z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M883.499 670.165a42.667 42.667 0 0 1-60.331-60.33l85.333-85.334a42.667 42.667 0 0 1 60.331 60.331l-85.333 85.333zM554.667 384H640a42.667 42.667 0 0 1 0 85.333H427.264V512h170.07a85.333 85.333 0 0 1 85.333 85.333V640a85.333 85.333 0 0 1-85.334 85.333h-42.666V768a42.667 42.667 0 0 1-85.334 0v-42.667H384A42.667 42.667 0 0 1 384 640h213.333v-42.667H427.264A85.333 85.333 0 0 1 341.931 512v-42.667A85.333 85.333 0 0 1 427.264 384h42.07v-42.667a42.667 42.667 0 0 1 85.333 0V384z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M823.168 499.499a42.667 42.667 0 0 1 60.33-60.331l85.334 85.333a42.667 42.667 0 0 1-60.33 60.331l-85.334-85.333zM256 597.333A42.667 42.667 0 0 0 256 512H128a42.667 42.667 0 0 0 0 85.333h128zM896 768a42.667 42.667 0 0 1 85.333 0v42.667a128 128 0 0 1-128 128H170.667a128 128 0 0 1-128-128V768A42.667 42.667 0 0 1 128 768v42.667a42.667 42.667 0 0 0 42.667 42.666h682.666A42.667 42.667 0 0 0 896 810.667V768zM128 341.888a42.667 42.667 0 0 1-85.333 0v-43.221a128 128 0 0 1 128-128h682.666a128 128 0 0 1 128 128v42.666a42.667 42.667 0 0 1-85.333 0v-42.666A42.667 42.667 0 0 0 853.333 256H170.667A42.667 42.667 0 0 0 128 298.667v43.221z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M140.501 670.165a42.667 42.667 0 0 0 60.331-60.33L115.499 524.5a42.667 42.667 0 0 0-60.331 60.331l85.333 85.333z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M200.832 499.499a42.667 42.667 0 1 0-60.33-60.331l-85.334 85.333a42.667 42.667 0 0 0 60.33 60.331l85.334-85.333z"
        />
    </Svg>
)

export const PaymentReceivedComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 94.35",
        }}
        viewBox="0 0 122.88 94.35"
        {...props}
    >
        <Path
            d="M93.05 81.54V44.62H76.44c-7.04 1.26-14.08 5.08-21.12 9.51h-12.9c-5.84.35-8.9 6.27-3.22 10.16 4.52 3.32 10.49 3.13 16.61 2.58 4.22-.21 4.4 5.46 0 5.48-1.53.12-3.19-.24-4.64-.24-7.64-.01-13.92-1.47-17.77-7.5l-1.93-4.51-19.19-9.51c-9.6-3.16-16.43 6.88-9.35 13.87 13.9 10.11 28.15 18.43 42.73 25.15 10.59 6.44 21.18 6.22 31.76 0l15.63-8.07zM34.38 15.9V0h25.17v15.98h12.17l-24.84 29.2L21.96 15.9h12.42zm88.5 25.17H98.05v44.18h24.83V41.07z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)

export const PaymentMadeComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 97.57",
        }}
        viewBox="0 0 122.88 97.57"
        {...props}
    >
        <Path
            d="M122.88 44.29H98.05v44.18h24.83V44.29zM93.05 84.76V47.84H76.44c-7.04 1.26-14.08 5.08-21.12 9.51h-12.9c-5.84.35-8.9 6.27-3.22 10.16 4.52 3.32 10.49 3.13 16.61 2.58 4.22-.21 4.4 5.46 0 5.48-1.53.12-3.19-.24-4.64-.24-7.64-.01-13.92-1.47-17.77-7.5l-1.93-4.51-19.2-9.52c-9.6-3.16-16.43 6.88-9.35 13.87 13.9 10.11 28.15 18.43 42.73 25.15 10.59 6.44 21.18 6.22 31.76 0l15.64-8.06zM59.3 29.28v15.9H34.13V29.2H21.96L46.8 0l24.92 29.28H59.3z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)

export const ItemsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 122.25",
            height: 40,
            width: 40,
            fill: props.color ?? 'white'
        }}
        viewBox="0 0 122.88 122.25"
    >
        <Path d="m122.57 29.25.31 62.88c.01 3.28-2.05 6.1-5 7.29l.01.01-54.64 22.09c-.99.4-2.05.6-3.12.6-.11 0-.22 0-.33-.01-.47.08-.95.13-1.42.13-1.06 0-2.11-.21-3.08-.62L4.94 100.46v-.01A8.116 8.116 0 0 1 0 92.94l.3-62.08c-.04-.66 0-1.33.12-1.99.02-.95.22-1.88.58-2.76.84-2.04 2.47-3.55 4.42-4.33v-.01L57.98.6a8.34 8.34 0 0 1 6.4.07l52.47 18.97c3.14 1.13 5.13 3.96 5.27 7.01.29.84.45 1.72.45 2.6zm-71.06 79.21.39-54.77L9.82 35.5l-.89 54.99 42.58 17.97zm62.07-72.96L66.55 53.7l.37 54.71 46.94-17.54-.28-55.37z" />
    </Svg>
)

export const ItemsAdjustmentsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width={122.88}
        height={117.824}
        {...props}
    >
        <Path
            fillRule="evenodd"
            d="M122.774 16.459c0 5.393-4.412 9.805-9.805 9.805H92.202a21.652 21.652 0 0 0 2.278-9.697 21.64 21.64 0 0 0-2.387-9.913h20.876c5.393 0 9.805 4.412 9.805 9.805zm-33.468 84.798c0 9.15-7.418 16.567-16.568 16.567s-16.567-7.417-16.567-16.567c0-9.149 7.417-16.567 16.567-16.567s16.568 7.417 16.568 16.567zm33.563-.109c0 5.393-4.413 9.805-9.806 9.805H92.202a21.651 21.651 0 0 0 2.278-9.696 21.64 21.64 0 0 0-2.387-9.913h20.97c5.394 0 9.806 4.412 9.806 9.804zm-69.597 9.805H9.816c-5.393 0-9.805-4.412-9.805-9.805s4.412-9.805 9.805-9.805h43.565a21.653 21.653 0 0 0-2.387 9.913c0 3.485.821 6.778 2.278 9.697zM28.326 58.717c0 9.149 7.418 16.567 16.568 16.567 9.149 0 16.567-7.418 16.567-16.567 0-9.15-7.418-16.568-16.567-16.568-9.15-.001-16.568 7.417-16.568 16.568zM0 58.608c0 5.393 4.414 9.805 9.805 9.805H25.48a21.52 21.52 0 0 1-2.278-9.696c0-3.528.861-6.941 2.387-9.914H9.805C4.412 48.803 0 53.215 0 58.608zm64.409 9.805h48.666c5.392 0 9.805-4.412 9.805-9.805 0-5.394-4.412-9.806-9.805-9.806H64.301a21.794 21.794 0 0 1 2.387 9.914 21.52 21.52 0 0 1-2.279 9.697zm24.897-51.846c0 9.15-7.418 16.567-16.568 16.567S56.17 25.718 56.17 16.567C56.17 7.417 63.587 0 72.737 0s16.569 7.417 16.569 16.567zm-36.034 9.697H9.853c-5.393 0-9.805-4.413-9.805-9.805 0-5.393 4.412-9.805 9.805-9.805h43.528a21.653 21.653 0 0 0-2.387 9.913c0 3.485.821 6.778 2.278 9.697z"
            clipRule="evenodd"
        />
    </Svg>
)


export const PrintBarcodeComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#231F20"
            d="M928 128H96a64 64 0 0 0-64 64v640a64 64 0 0 0 64 64h832a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zM256 768h-96V288h96zm128-96h-64V288h64zm192 0h-96V288h96zm128 0h-64V288h64zm160 96h-96V288h96z"
        />
    </Svg>
)

export const ContactsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#000"
            d="M118.187 205.653a87.467 87.467 0 0 1 87.466-87.466h612.694c48.128 0 87.466 39.338 87.466 87.466v612.694a87.765 87.765 0 0 1-87.466 87.466H205.653a87.467 87.467 0 0 1-87.466-87.466V205.653zm551.338 188.16A157.312 157.312 0 0 0 512 236.331a157.312 157.312 0 0 0-157.525 157.568A157.312 157.312 0 0 0 512 551.38a157.312 157.312 0 0 0 157.525-157.525zM236.288 739.712v48.043h551.424v-48.043c0-96.085-183.808-148.907-275.712-148.907s-275.712 52.822-275.712 148.907z"
        />
    </Svg>
)

export const SalesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M273.067 870.4a102.4 102.4 0 1 0 204.8 0 102.4 102.4 0 1 0-204.8 0ZM716.8000000000001 870.4a102.4 102.4 0 1 0 204.8 0 102.4 102.4 0 1 0-204.8 0ZM1020.587 194.56c-3.414-3.413-6.827-6.827-13.654-6.827h-819.2l-27.306-122.88c0-6.826-10.24-13.653-17.067-13.653H17.067C6.827 51.2 0 58.027 0 68.267s6.827 17.066 17.067 17.066h112.64L235.52 614.4c13.653 68.267 71.68 119.467 143.36 119.467H870.4c10.24 0 17.067-6.827 17.067-17.067s-6.827-17.067-17.067-17.067H378.88c-44.373 0-85.333-27.306-102.4-68.266l645.12-81.92c6.827 0 13.653-6.827 13.653-13.654L1024 208.213c0-3.413 0-10.24-3.413-13.653zM215.04 331.093l54.613 266.24h-3.413l-51.2-266.24z" />
    </Svg>
)

export const TableManagementComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 122.88 67.17"
        {...props}
        style={{
            width: 48,
            height: 36,
            color: props.color ?? "white",
        }}
    >
        <Path
            d="M36.62 15.45a.5.5 0 0 0 .21.05h20.51v48h-1a1.87 1.87 0 0 0-1.86 1.86 1.87 1.87 0 0 0 1.86 1.86h12a1.86 1.86 0 0 0 1.85-1.86 1.86 1.86 0 0 0-1.85-1.86h-1v-48h18.71a.59.59 0 0 0 .22-.05h2a4.53 4.53 0 0 0 4.52-4.52 4.53 4.53 0 0 0-4.52-4.52H34.66a4.53 4.53 0 0 0-4.52 4.52 4.53 4.53 0 0 0 4.52 4.52ZM1.74 0h4.59A1.83 1.83 0 0 1 8 1.7a203.24 203.24 0 0 1 2.62 32.76H42a2.25 2.25 0 0 1 2.25 2.25v4.54h-1.8v23.24a.69.69 0 0 1-.68.68h-6a.68.68 0 0 1-.69-.68V54.38H9.41Q8.85 59 8 63.63a1.84 1.84 0 0 1-1.7 1.7H1.74c-.93 0-2-.81-1.7-1.7 6-21 4.78-41.6 0-61.93C-.17.79.81 0 1.74 0Zm33.33 51.25v-10H10.55c-.13 4.25-.43 5.75-.88 10ZM121.14 0h-4.59a1.83 1.83 0 0 0-1.7 1.7 203.24 203.24 0 0 0-2.62 32.76H80.88a2.25 2.25 0 0 0-2.25 2.25v4.54h1.8v23.24a.69.69 0 0 0 .68.68h6a.68.68 0 0 0 .69-.68V54.38h25.66q.56 4.62 1.38 9.25a1.84 1.84 0 0 0 1.7 1.7h4.59c.93 0 2-.81 1.7-1.7-6-21-4.78-41.6 0-61.93.21-.91-.77-1.7-1.7-1.7ZM87.81 51.25v-10h24.52c.13 4.25.43 5.75.88 10Z"
            style={{
                fillRule: "evenodd",
                fill: props.color ?? "white",
            }}
        />
    </Svg>
)

export const ProductionWorkflowIconComponent = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            color: props.color ?? "white",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M782 684c19.882 0 36 16.118 36 36v140c0 19.882-16.118 36-36 36H422c-19.882 0-36-16.118-36-36V720c0-19.882 16.118-36 36-36h360zm64-486 .595.005C866.203 198.323 882 214.317 882 234v278l-.005.595C881.677 532.203 865.683 548 846 548H636.128l-101.379 82.2c-13.216 10.717-32.13 10.717-45.346 0L388.023 548H214v206h106l.595.005C340.203 754.323 356 770.317 356 790c0 19.882-16.118 36-36 36H178l-.595-.005C157.797 825.677 142 809.683 142 790V512l.005-.595C142.323 491.797 158.317 476 178 476h210.608l100.795-81.726c13.216-10.715 32.13-10.715 45.346 0L635.543 476H810V270H704l-.595-.005C683.797 269.677 668 253.683 668 234c0-19.882 16.118-36 36-36h142zM746 756H458v68h288v-68zM512.076 468.583l-53.839 43.654 53.839 43.654 53.84-43.654-53.84-43.654zM602 128c19.882 0 36 16.118 36 36v140c0 19.882-16.118 36-36 36H242c-19.882 0-36-16.118-36-36V164c0-19.882 16.118-36 36-36h360zm-36 72H278v68h288v-68z"
        />
    </Svg>
)

export const ProductionOrderComponent = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            fill: props.color ?? "white",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M425.352 320.768c17.66 0 31.978-14.317 31.978-31.979s-14.317-31.978-31.978-31.978H248.783c-17.661 0-31.978 14.317-31.978 31.978s14.317 31.979 31.978 31.979h176.569zm64.44 129.328H263.673c-17.661 0-31.978 14.317-31.978 31.978s14.317 31.979 31.978 31.979h226.12c17.66 0 31.978-14.317 31.978-31.979s-14.318-31.978-31.979-31.978zm-5.05 190.463H262.78c-17.661 0-31.978 14.317-31.978 31.978s14.317 31.979 31.978 31.979H484.74c17.661 0 31.978-14.317 31.978-31.979s-14.316-31.978-31.977-31.978zm183.32 187.922H146.097c-8.882 0-16.673-5.942-16.673-12.717V201.367c0-6.774 7.791-12.716 16.673-12.716h521.965c8.883 0 16.673 5.942 16.673 12.716v55.537h63.957v-55.537c0-42.277-36.171-76.673-80.63-76.673H146.097c-44.46 0-80.63 34.395-80.63 76.673v614.397c0 42.277 36.17 76.674 80.63 76.674h521.965c44.459 0 80.63-34.396 80.63-76.674h-63.957c0 6.775-7.791 12.717-16.673 12.717zm170.095-441.052-.01-.197c-2.085-38.2-24.665-74.288-60.403-96.537a12.81 12.81 0 0 0-6.762-1.93c-6.16 0-11.47 4.366-12.626 10.382l-15.835 82.434-85.467-15.328c-1.037-.186-1.89-.727-2.47-1.57-.505-.733-.691-1.558-.536-2.385l14.904-79.205c.687-3.65-.601-7.46-3.357-9.938a10.68 10.68 0 0 0-10.241-2.305c-45.448 13.604-78.542 48.143-86.368 90.14-8.434 45.275 13.882 92.42 56.857 120.107 13.27 8.55 27.178 25.983 26.816 41.36l-9.207 205.245-.005.191c0 30.785 25.536 55.832 56.925 55.832 15.177 0 29.456-5.81 40.209-16.361 10.782-10.579 16.719-24.65 16.718-39.621l-9.11-201.141c-.374-15.865 13.925-30.671 27.37-37.713 28.92-15.15 50.203-40.168 58.914-69.062l.871.154 1.332-8.484c.719-1.737.979-3.513.774-5.297l.707-18.771zM726.775 527.195l9.103 200.791c-.052 18.93-15.96 34.313-35.505 34.313-19.543 0-35.45-15.317-35.503-34.163l9.202-205.087c.58-24.612-18.578-48.335-36.624-59.961-36.177-23.309-54.34-60.928-47.4-98.175 5.316-28.524 25.388-53.079 54.304-66.93l-11.355 60.352c-1.219 6.475.186 13.048 3.955 18.51 3.837 5.567 9.633 9.293 16.322 10.494l96.898 17.377c.247.086.498.162.764.222l62.275 11.098c-7.516 22.64-24.264 41.651-47.595 53.872-19.763 10.356-39.439 32.055-38.841 57.287zm90.118-132.276-53.282-9.556 13.29-69.192c26.201 20.331 40.835 49.107 39.992 78.748z" />
    </Svg>
)

export const AppointmentsComponent = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M847.462 101.837C947.661 117.555 1024 199.117 1024 297.267v528.589C1024 935.27 929.126 1024 812.134 1024H211.866C94.874 1024 0 935.27 0 825.805V297.267c0-96.665 74.598-179.302 176.538-195.379v67.482c-60.928 14.694-105.933 66.406-105.933 128v528.486c0 35.02 14.848 68.608 41.37 93.44a146.33 146.33 0 0 0 99.84 38.707h600.32c78.028 0 141.26-59.187 141.26-132.147V297.267c0-60.211-43.571-112.845-105.984-127.949v-67.43zM468.941 720.845a46.797 46.797 0 0 1-62.669 0L260.147 585.37a39.526 39.526 0 0 1-13.005-29.03c0-10.906 4.71-21.402 13.005-29.031a46.797 46.797 0 0 1 62.618 0l114.79 106.393 240.128-222.566a46.797 46.797 0 0 1 62.618 0c8.294 7.68 12.953 18.125 12.953 29.03a39.526 39.526 0 0 1-12.953 29.082L468.89 720.845zM282.47 0c19.507 0 35.327 14.797 35.327 33.024v165.171c0 18.227-15.82 33.024-35.328 33.024-19.456 0-35.328-14.797-35.328-33.024V33.024c0-8.704 3.738-17.152 10.394-23.347A36.608 36.608 0 0 1 282.47 0zM741.53 0c19.456 0 35.328 14.797 35.328 33.024v165.171c0 18.227-15.872 33.024-35.328 33.024-19.508 0-35.328-14.797-35.328-33.024V33.024C706.202 14.797 722.022 0 741.53 0zM388.403 99.072h247.194v66.048H388.403V99.072z"
        />
    </Svg>
)

export const LeadsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M879.381 687.988H527.286c-9.088 0-16.455 7.275-16.455 16.25v239.071c0 8.974 7.367 16.25 16.455 16.25h352.095c9.088 0 16.455-7.275 16.455-16.25V704.238c0-8.975-7.367-16.25-16.455-16.25zm-65.759 213.946H593.044c-15.228 0-27.572-12.344-27.572-27.572s12.344-27.572 27.572-27.572h220.578c15.228 0 27.572 12.345 27.572 27.572s-12.344 27.572-27.572 27.572zm0-101.177H593.044c-15.228 0-27.572-12.345-27.572-27.572 0-15.228 12.344-27.572 27.572-27.572h220.578c15.228 0 27.572 12.345 27.572 27.572.001 15.227-12.344 27.572-27.572 27.572zm26.51-172.066H454.781a4.557 4.557 0 0 0-4.557 4.557V955a4.557 4.557 0 0 1-4.557 4.557H71.675c-2.31 0-4.268-1.725-4.533-4.02a444.512 444.512 0 0 1-2.413-29.559c-12.461-258.88 201.553-473.744 460.479-462.283 127.799 5.657 241.466 65.687 318.43 157.522 2.482 2.96.356 7.474-3.506 7.474zM283.291 284.446a220.578 220.578 0 1 0 441.156 0 220.578 220.578 0 1 0-441.156 0Z" />
    </Svg>
)

export const BroadcastComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M932.571 54.857c-4.342 0-8.8.8-13.257 2.629L260.571 322.17H73.143c-10.057 0-18.286 8.458-18.286 18.972v341.714c0 10.514 8.229 18.972 18.286 18.972H189.37c-4.228 13.257-6.514 27.314-6.514 41.6C182.857 818.743 244.343 880 320 880c63.314 0 116.686-42.971 132.457-101.029L919.43 966.63c4.457 1.714 8.914 2.628 13.257 2.628 19.314 0 36.571-16.228 36.571-37.943V92.8c-.114-21.714-17.257-37.943-36.686-37.943zM320 798.057c-30.286 0-54.857-24.457-54.857-54.628 0-12.8 4.457-25.029 12.571-34.743l97.029 38.971c-2.286 28.114-25.943 50.4-54.743 50.4zM886.857 864.8 291.2 625.486l-14.743-5.943H137.143V404.457h139.314l14.743-5.943L886.857 159.2v705.6z" />
    </Svg>

)

export const PosComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M682.667 256h170.666a85.333 85.333 0 0 1 85.334 85.333v341.334A85.333 85.333 0 0 1 853.333 768H682.667v82.816c0 48-37.632 87.85-85.334 87.85H170.667c-47.702 0-85.334-39.85-85.334-87.85v-677.59c0-48.042 37.632-87.893 85.334-87.893h426.666c47.702 0 85.334 39.851 85.334 87.851V256zm170.666 213.333H682.667v213.334h170.666V469.333zm-256 381.483v-677.59c0-1.962-.554-2.56 0-2.56H170.667c.554 0 0 .598 0 2.518v677.59c0 1.92.554 2.517 0 2.517h426.666c-.554 0 0-.598 0-2.518zm-384-40.15v-85.333h85.334v85.334h-85.334zm128 0v-85.333h85.334v85.334h-85.334zm128 0v-85.333h85.334v85.334h-85.334zm-256-128v-85.333h85.334v85.334h-85.334zm128 0v-85.333h85.334v85.334h-85.334zm128 0v-85.333h85.334v85.334h-85.334zm85.334-469.333v341.334H213.333V213.333h341.334zm-256 85.334v170.666h170.666V298.667H298.667zM853.333 384v-42.667H682.667V384h170.666z" />
    </Svg>
)

export const KitchenComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M504.32 75c60.717 0 117.286 25.224 157.64 68.199l1.208 1.297.734-.167a216.795 216.795 0 0 1 46.463-5.299l1.315-.004c119.472 0 216.32 96.888 216.32 216.396 0 94.83-61.409 176.945-148.676 205.608l-.658.21v314.076c0 40.832-32.76 74.014-73.431 74.674L704 950H320c-41.24 0-74.667-33.44-74.667-74.684V561.24l-.657-.21C158.368 532.68 97.353 452.05 96.022 358.543L96 355.422c0-119.508 96.847-216.396 216.32-216.396 11.636 0 23.16.922 34.493 2.741l1.062.174.84-.876c39.809-41.256 94.704-65.516 153.596-66.056zm210.346 640.236H309.333v160.08c0 5.809 4.625 10.53 10.383 10.68L320 886h384c5.889 0 10.667-4.78 10.667-10.684l-.001-160.08zM504.32 139c-47.231 0-90.84 21.605-119.585 57.992l-.281.35a32 32 0 0 1-33.024 10.747l-1.224-.32c-12.262-3.137-24.953-4.743-37.886-4.743-84.12 0-152.32 68.228-152.32 152.396 0 73.385 52.242 135.98 123.374 149.655l.45.09c14.835 3.07 25.51 16.144 25.51 31.334l-.001 114.735h85.333v-96.052c0-17.673 14.328-32 32-32 17.497 0 31.714 14.042 31.996 31.471l.005.53-.001 96.051h256V536.501c0-15.19 10.675-28.264 25.51-31.334l.45-.09 2.128-.425C812.798 490.15 864 428.074 864 355.422c0-84.168-68.2-152.396-152.32-152.396-17.035 0-33.647 2.786-49.385 8.18l-.424.141a32 32 0 0 1-35.563-11.23l-.863-1.142C596.794 161.449 552.45 139 504.32 139z" />
    </Svg>
)

export const QuotationComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M551.768 851.608c-1.262 1.894-2.525 6.312-2.525 6.312l-20.2 85.218s-1.262 8.837 2.525 12.625c4.42 3.787 13.257 3.787 13.257 3.787l85.217-20.2s5.05-1.262 8.206-2.524c2.525-1.263 5.681-4.42 5.681-4.42l295.422-295.42s6.312-5.681 6.943-11.363c.631-5.68-5.05-12.624-5.05-12.624l-63.755-63.756s-4.419-5.05-11.994-5.05-12.625 6.313-12.625 6.313L556.187 847.189c-.631-1.262-3.156 2.525-4.419 4.419zm-78.274 95.317 29.037-116.148s1.894-6.312 3.788-10.1c2.525-4.419 6.943-8.837 6.943-8.837l356.652-356.652s6.312-5.68 8.837-12.625c3.157-7.574 3.157-17.674 3.157-17.674V131.36c0-37.243-30.3-68.174-68.175-68.174H211.53c-37.243 0-68.174 30.3-68.174 68.174v761.91c0 37.243 30.3 68.174 68.174 68.174h242.397s6.943-.631 12.625-5.05c5.68-5.05 6.943-9.469 6.943-9.469zM317.578 243.722H710.84c17.675 0 32.193 14.519 32.193 32.194s-14.518 32.193-32.193 32.193H317.578c-17.675 0-32.194-14.519-32.194-32.193s14.519-32.194 32.194-32.194zm0 195.685H553.03c17.674 0 32.193 14.519 32.193 32.194s-13.887 32.193-32.193 32.193H317.578c-17.675 0-32.194-14.519-32.194-32.193s14.519-32.194 32.194-32.194zm-32.194 232.297c0-17.675 14.519-32.193 32.194-32.193h96.58c17.674 0 32.193 14.518 32.193 32.193s-14.519 32.193-32.193 32.193h-96.58c-17.675 0-32.194-14.518-32.194-32.193z" />
    </Svg>
)

export const SalesOrderComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#000"
            d="M512 48c55.784 0 102.04 40.776 110.584 94.152l.28 1.84L803.44 144c50.048 0 91.256 38.84 92.528 87.84l.032 2.344v603.632c0 49.32-40.424 88.928-90.184 90.16l-2.376.024H220.56c-50.048 0-91.256-38.84-92.528-87.84l-.032-2.344V234.184c0-49.32 40.424-88.928 90.184-90.16l2.376-.024h180.576l-.096.656C408.52 90.064 455.36 48 512 48zm224 620H304l-1.6.04a32 32 0 0 0 0 63.92l1.6.04h432l1.6-.04a32 32 0 0 0 0-63.92L736 668zm0-168H304l-1.6.04a32 32 0 0 0 0 63.92l1.6.04h432l1.6-.04a32 32 0 0 0 0-63.92L736 500zm0-168H304l-1.6.04a32 32 0 0 0 0 63.92l1.6.04h432l1.6-.04a32 32 0 0 0 0-63.92L736 332zM512 112a48 48 0 1 0 0 96 48 48 0 0 0 0-96z"
        />
    </Svg>
)


export const DeliveryOrderComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M35.93 631.67V195.997c0-24.21 19.625-43.837 43.837-43.837h435.45c24.21 0 43.835 19.627 43.835 43.837v435.676a14.61 14.61 0 0 1-14.612 14.613H50.542A14.612 14.612 0 0 1 35.93 631.67zm351.64 149.254c0 50.213-40.707 90.918-90.918 90.918s-90.918-40.705-90.918-90.918c0-50.215 40.707-90.919 90.918-90.919s90.919 40.704 90.919 90.919zm-45.46 0c0-25.107-20.353-45.46-45.46-45.46s-45.46 20.353-45.46 45.46 20.354 45.46 45.46 45.46 45.46-20.354 45.46-45.46zm-123.765-90.92H14.612A14.612 14.612 0 0 0 0 704.616v44.331a14.612 14.612 0 0 0 14.612 14.612h163.301c4.264-29.254 19.03-55.095 40.432-73.555zm644.924 90.92c0 50.213-40.708 90.918-90.919 90.918-50.212 0-90.918-40.705-90.918-90.918 0-50.215 40.706-90.919 90.918-90.919 50.211-.001 90.919 40.704 90.919 90.919zm-45.458 0c0-25.107-20.354-45.46-45.46-45.46-25.109 0-45.46 20.353-45.46 45.46s20.353 45.46 45.46 45.46 45.46-20.354 45.46-45.46zM1024 704.616v44.331a14.612 14.612 0 0 1-14.612 14.612H891.086c-8.462-58.031-58.405-102.78-118.732-102.78-60.34 0-110.284 44.75-118.746 102.78H415.391c-4.265-29.252-19.03-55.095-40.431-73.555h225.872V272.053c0-16.14 13.084-29.224 29.224-29.224h137.947a116.89 116.89 0 0 1 96.879 51.484l88.93 131.716a116.898 116.898 0 0 1 20.015 65.412v198.563h35.56A14.612 14.612 0 0 1 1024 704.616zM875.768 429.402l-71.113-101.05a14.614 14.614 0 0 0-11.95-6.202H681.78a14.614 14.614 0 0 0-14.612 14.612v101.05a14.61 14.61 0 0 0 14.612 14.612H863.82c11.836 0 18.76-13.34 11.947-23.022z" />
    </Svg>
)

export const InvoicesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M824 76H199.2c-47.2 0-85.6 38-85.6 88.7v738.1c0 11.6 13.3 24.5 30.3 25.3l10.1.5c1.8.1 1.8.1 6.8 3.1 10 6 26.7 15.9 55.1 15.9 28.7 0 55.3-10 65.2-16 5.2-3.2 5.2-3.2 8.4-3.2 3.1 0 3.1 0 8.4 3.2 10 6 26.5 16 55.2 16s45.3-10 55.2-16c5.3-3.2 5.3-3.2 8.4-3.2 3.1 0 3.1 0 8.3 3.1 10 6.1 26.5 16.1 55.2 16.1s45.3-10 55.2-16c5.3-3.2 5.3-3.2 8.4-3.2s3.1 0 8.4 3.2c10 6 26.6 16 55.2 16 28.7 0 45.3-10 55.2-16 5.3-3.2 5.3-3.2 8.4-3.2 3.1 0 3.1 0 8.3 3.1 10 6.1 26.5 16.1 55.2 16.1s55.3-10 65.2-16c5.3-3.2 5.3-3.2 8.4-3.2 3.4 0 3.4 0 8.9 3.3 8.9 5.2 23.7 14 47.5 15.5l11.4.7c.8.1 1.5.1 2.3.1 17.4 0 31.8-12.9 31.4-25.4V164.7C909.6 114 871.2 76 824 76zM352 288.5h210c22 0 40 18 40 40s-18 40-40 40H352c-22 0-40-18-40-40s18-40 40-40zm100 447H352c-22 0-40-18-40-40s18-40 40-40h100c22 0 40 18 40 40s-18 40-40 40zm220-183H352c-22 0-40-18-40-40s18-40 40-40h320c22 0 40 18 40 40s-18 40-40 40z" />
    </Svg>
)

export const SalesReturnComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M776.342 115.987c24.151 0 47.079 10.69 62.564 29.221l76.075 90.936a81.587 81.587 0 0 1 14.511 25.625 22.228 22.228 0 0 1 2.098 7.193c1.599 6.344 2.398 12.888 2.398 19.531v532.355a81.57 81.57 0 0 1-81.57 81.57H154.1a81.57 81.57 0 0 1-81.57-81.57v-532.38a81.683 81.683 0 0 1 18.98-52.349l76.101-90.91a81.57 81.57 0 0 1 62.564-29.247zm113.14 177.801H117.01v527.06c0 19.257 14.71 35.116 33.517 36.89l3.572.174h698.318c20.48 0 37.088-16.584 37.088-37.064v-527.06zm-495.766 93.883a22.228 22.228 0 0 1 2.997 29.097l-1.924 2.348-25.8 27.648h197.832c79.173 0 143.785 61.59 143.785 138.115 0 74.377-61.065 134.668-137.216 137.94l-6.569.15H381.627a22.228 22.228 0 0 1-2.997-44.282l2.997-.2h185.22c55.07 0 99.302-42.158 99.302-93.608 0-49.702-41.21-90.687-93.658-93.459l-5.645-.15H374.36l23.752 22.179a22.228 22.228 0 0 1 2.997 29.096l-1.898 2.348a22.228 22.228 0 0 1-29.096 2.997l-2.348-1.898-65.087-60.69a22.228 22.228 0 0 1-2.997-29.098l1.898-2.347 60.691-65.087a22.228 22.228 0 0 1 31.47-1.099zm87.29-227.203H230.15a37.18 37.18 0 0 0-28.472 13.287l-63.188 75.527h342.54v-88.814zm295.336 0H525.487v88.789h342.49L804.79 173.73c-6.244-7.492-15.185-12.163-24.8-13.112l-3.647-.175z"
        />
    </Svg>
)

export const CreditNotesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#2C2C2C"
            d="M522.24 870.4 768 629.76l97.28 97.28-245.76 240.64zm419.84-261.12c10.24 10.24 10.24 30.72 0 46.08L896 701.44l-97.28-97.28 40.96-40.96c15.36-15.36 46.08-15.36 61.44 0l40.96 46.08zm-471.04 394.24L496.64 896l97.28 97.28-112.64 25.6c-5.12 0-15.36-5.12-10.24-15.36zM768 0H204.8c-71.68 0-128 61.44-128 143.36v737.28c0 81.92 56.32 143.36 128 143.36h102.4L896 450.56v-307.2C896 61.44 839.68 0 768 0zM665.6 465.92H307.2c-15.36 0-25.6-10.24-25.6-30.72 0-15.36 10.24-25.6 25.6-25.6h358.4c15.36 0 25.6 10.24 25.6 30.72 0 15.36-10.24 25.6-25.6 25.6zm0-174.08H307.2c-15.36 0-25.6-10.24-25.6-30.72 0-15.36 10.24-30.72 25.6-30.72h358.4c15.36 0 25.6 10.24 25.6 30.72 0 20.48-10.24 30.72-25.6 30.72z"
        />
    </Svg>
)

export const PurchasesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 94.27",
        }}
        viewBox="0 0 122.88 94.27"
        {...props}
    >
        <Path
            d="M12.04 27.72h9.43L44.56 1.86c2.05-2.3 5.61-2.5 7.9-.45 2.3 2.05 2.5 5.61.45 7.91l-16.42 18.4h50.32L70.39 9.32c-2.05-2.3-1.85-5.86.45-7.91 2.3-2.05 5.85-1.85 7.91.45l23.08 25.86h17.61c1.9 0 3.45 1.55 3.45 3.45v9.73c0 1.9-1.55 3.45-3.45 3.45h-7.33l-3.77 47.53c-.1 1.31-1.08 2.39-2.39 2.39H16.94c-1.31 0-2.29-1.08-2.39-2.39l-3.77-47.53H3.45C1.55 44.35 0 42.8 0 40.9v-9.73c0-1.9 1.55-3.45 3.45-3.45h8.59zm65.63 18.5h10.91v31.53H77.67V46.22zm-21.22 0h10.9v31.53h-10.9V46.22zm-21.22 0h10.91v31.53H35.23V46.22z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)

export const PurchaseOrderComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 112.75",
        }}
        viewBox="0 0 122.88 112.75"
        {...props}
    >
        <Path
            d="M19.78 16.38h47.97c-.64 2.13-1.05 4.35-1.22 6.65l-4.71-.01 4.81 19.99h5.34a31.35 31.35 0 0 0 4.4 5.08h-8.51l4.08 16.99 11.76-1.6-2.86-11.92c2.39 1.52 5 2.73 7.77 3.56l1.79 7.44.85-.12c5.31-.76 4.95.45 5.37-4.55l.12-1.48a31.171 31.171 0 0 0 6.67-.54l-.53 6.82c-.52 6.16-.08 4.67-6.61 5.6l-59.96 7.63 3.17 9.21h64.59c.88 3.27 2.06 8.59 2.94 12.24H96.26l-1.03-3.73H43.62c-11.84-.2-10.65 3-13.49-7.22L9.77 12.46H0V5.37h17.13c.8 2.98 1.91 8 2.65 11.01zM97.56 0c13.98 0 25.32 11.34 25.32 25.32s-11.34 25.32-25.32 25.32S72.24 39.3 72.24 25.32 83.58 0 97.56 0zm-11.2 25.99c.34-1.97 2.59-3.07 4.36-2 .16.1.31.21.46.34l.01.01c.8.76 1.69 1.56 2.57 2.34l.76.68 9-9.44c.54-.56.93-.93 1.74-1.11 2.76-.61 4.7 2.77 2.75 4.83L96.79 33.43c-1.06 1.13-2.95 1.23-4.08.15-.65-.6-1.36-1.22-2.07-1.84-1.24-1.08-2.5-2.18-3.53-3.26-.63-.62-.9-1.64-.75-2.49zm-39.44 70.2c4.57 0 8.28 3.71 8.28 8.29 0 4.58-3.71 8.28-8.28 8.28-4.58 0-8.29-3.71-8.29-8.28 0-4.58 3.71-8.29 8.29-8.29zm34.17 0c4.57 0 8.28 3.71 8.28 8.29 0 4.58-3.71 8.28-8.28 8.28-4.58 0-8.29-3.71-8.29-8.28 0-4.58 3.71-8.29 8.29-8.29zM26.92 43.01h13.19l-4.79-20.02c-4.71 0-9.37-.01-13.92-.01l1.61 5.99.05-.01 3.86 14.05zM42.22 23l4.79 20.01h12.71l-4.81-20L42.22 23zm23.02 43-4.3-17.9H48.23l4.69 19.59L65.24 66zm-19.02 2.59-4.9-20.5h-13L34.4 70.2l11.82-1.61z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)

export const BillsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="M897.74 150.426 751.719 20.787c-6.348-6.758-14.95-10.547-23.756-10.547H150.016c-18.74 0-33.894 16.384-33.894 36.454v832.922c0 9.83 3.686 19.558 10.342 26.214l102.298 93.696c18.022 14.132 37.376 5.837 47.001 0l104.448-94.617 108.442 98.611c19.763 12.902 29.696 10.24 47.001 0l108.442-98.611 108.237 98.611c9.625 7.066 15.053 10.24 23.552 10.24 8.397 0 15.053-3.789 23.552-10.24l98.099-89.088c6.554-6.963 10.342-16.384 10.342-26.214V176.23c0-9.625-3.686-19.046-10.137-25.804zm-43.314 739.328-67.072 63.488-113.05-92.365c-16.486-13.21-33.382-13.21-49.05 0l-113.152 92.365-113.152-92.365c-8.908-6.656-15.667-10.445-24.473-10.445-8.909 0-15.872 3.891-24.576 10.445l-104.96 92.16-75.674-71.885V62.976h546.714v98.816c0 12.493 9.523 22.835 21.197 22.835H854.22l.205 705.127zM239.82 615.424h156.672v55.5H239.82v-55.5zm0-226.714H348.16v55.501H239.82v-55.5zm0 111.719h128v58.88h-128v-58.88zM503.398 608.87c-31.334 0-56.73 25.396-56.73 56.73s25.396 56.73 56.73 56.73 56.73-25.396 56.73-56.73-25.395-56.73-56.73-56.73zm170.087 0c-31.335 0-56.73 25.396-56.73 56.73s25.395 56.73 56.73 56.73 56.73-25.396 56.73-56.73-25.396-56.73-56.73-56.73zm87.142-297.062H446.976l-7.782-28.672c-5.94-25.805-22.016-28.672-29.696-28.672H300.544c-15.872 0-28.672 12.902-28.672 28.672 0 15.872 12.8 28.672 28.672 28.672h87.04l57.344 206.643c5.427 16.999 18.125 22.835 28.672 22.835h229.58c11.88 0 22.426-6.041 28.673-22.425l49.254-149.709c4.403-13.926 8.192-21.504 8.192-28.672 0-19.046-16.384-28.672-28.672-28.672z" />
    </Svg>
)

export const DebitNotesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1066 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M284.587 40.021a21.333 21.333 0 0 0-16.384 7.68L103.21 245.675a42.667 42.667 0 0 0-9.899 27.306v689.707a21.333 21.333 0 0 0 21.333 21.333H983.98a21.333 21.333 0 0 0 21.333-21.333V272.981a42.667 42.667 0 0 0-9.856-27.306L830.464 47.7a21.333 21.333 0 0 0-16.384-7.68H284.587zm-65.835 192 93.312-112h474.539l93.312 111.958H218.752zm-45.397 80h752v592h-752v-592zm88.405 149.462 159.659-91.264a21.333 21.333 0 0 1 31.914 18.56v51.2h360.022V776.02H437.333v-80h296.022v-176H453.333v51.2a21.333 21.333 0 0 1-31.914 18.518L261.76 498.517a21.333 21.333 0 0 1 0-37.034z"
        />
    </Svg>
)

export const AccountingComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 103.19 122.88"
        {...props}
    >
        <Path
            fillRule="evenodd"
            d="M17.16 0h82.72a3.32 3.32 0 0 1 3.31 3.31v92.32c-.15 2.58-3.48 2.64-7.08 2.48H15.94c-4.98 0-9.05 4.07-9.05 9.05s4.07 9.05 9.05 9.05h80.17v-9.63h7.08v12.24c0 2.23-1.82 4.05-4.05 4.05H16.29C7.33 122.88 0 115.55 0 106.59V17.16C0 7.72 7.72 0 17.16 0zm3.19 13.4h2.86c1.46 0 2.66.97 2.66 2.15v67.47c0 1.18-1.2 2.15-2.66 2.15h-2.86c-1.46 0-2.66-.97-2.66-2.15V15.55c.01-1.19 1.2-2.15 2.66-2.15z"
            clipRule="evenodd"
        />
    </Svg>
)


export const TaxesComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#000"
            d="M832 96a96 96 0 0 1 96 96v640a96 96 0 0 1-96 96H192a96 96 0 0 1-96-96V192a96 96 0 0 1 96-96h640zm-98.464 640h-448l-3.712.224a32 32 0 0 0 0 63.552l3.712.224h448l3.744-.224A32 32 0 0 0 733.536 736zm-78.24-288a96 96 0 1 0 0 192 96 96 0 0 0 0-192zm2.176-168.544-3.008 2.688-303.232 303.232-2.688 3.008a32 32 0 0 0 44.928 44.896l3.008-2.656 303.232-303.232 2.656-3.008a32 32 0 0 0-44.896-44.928zM655.296 512a32 32 0 1 1 0 64 32 32 0 0 1 0-64zM384 288a96 96 0 1 0 0 192 96 96 0 0 0 0-192zm0 64a32 32 0 1 1 0 64 32 32 0 0 1 0-64z"
        />
    </Svg>
)

export const TaxGroupsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 90.82",
        }}
        viewBox="0 0 122.88 90.82"
        {...props}
    >
        <Path
            d="M121.57 40.15c.85 1.42 1.31 2.94 1.31 4.51 0 8.34-12.9 15.1-28.8 15.1s-28.8-6.76-28.8-15.1c0-1.57.46-3.09 1.31-4.51 3.66 6.13 14.58 10.59 27.49 10.59 12.91 0 23.83-4.45 27.49-10.59zM56.29 62.64c.85 1.43 1.31 2.94 1.31 4.51 0 8.34-12.9 15.1-28.8 15.1S0 75.49 0 67.15c0-1.57.46-3.09 1.31-4.51C4.97 68.77 15.9 73.23 28.8 73.23c12.91 0 23.83-4.45 27.49-10.59zM32.98 40.56l-.06-3.74c.85-.03 1.54-.29 2.07-.77.54-.48.83-1.06.89-1.74.07-.78-.19-1.46-.77-2.06-.58-.59-1.52-.95-2.79-1.06-1.19-.1-2.11.09-2.75.57-.64.48-1 1.15-1.07 2.01-.09 1.07.3 2.07 1.17 3l-.7 2.98-9.94-2.79.85-9.84 3.48.3-.61 7.02 3.25.87c-.34-.87-.48-1.73-.4-2.6.14-1.65.87-3 2.16-4.04 1.3-1.04 2.91-1.48 4.83-1.31 1.6.14 2.98.72 4.15 1.76 1.6 1.41 2.31 3.24 2.11 5.48-.16 1.79-.76 3.21-1.82 4.26-1.05 1.06-2.4 1.63-4.05 1.7zm-4.18-15c13.07 0 23.67 4.16 23.67 9.28 0 5.13-10.6 9.28-23.67 9.28S5.13 39.98 5.13 34.85s10.6-9.29 23.67-9.29zm0-3.07c15.9 0 28.8 6.76 28.8 15.1s-12.9 15.1-28.8 15.1C12.9 52.68 0 45.92 0 37.59c0-8.34 12.9-15.1 28.8-15.1zm27.59 25.16c.78 1.37 1.21 2.83 1.21 4.33 0 8.34-12.9 15.1-28.8 15.1S0 60.32 0 51.99c0-1.51.42-2.96 1.21-4.33 3.56 6.22 14.56 10.76 27.59 10.76 13.03-.01 24.04-4.54 27.59-10.77zm48.09-38.7-.33 3.75-14.14-1.23c1.17 1.48 1.97 3.18 2.42 5.09l-3.4-.3c-.23-1-.75-2.12-1.54-3.34-.8-1.23-1.77-2.1-2.93-2.63l.27-3.04 19.65 1.7zm-10.4-5.87c13.07 0 23.67 4.16 23.67 9.28 0 5.13-10.6 9.28-23.67 9.28-13.07 0-23.67-4.16-23.67-9.28 0-5.13 10.6-9.28 23.67-9.28zm0-3.08c15.9 0 28.8 6.76 28.8 15.1s-12.9 15.1-28.8 15.1-28.8-6.76-28.8-15.1S78.18 0 94.08 0zm27.59 25.16c.78 1.37 1.21 2.83 1.21 4.33 0 8.34-12.9 15.1-28.8 15.1s-28.8-6.76-28.8-15.1c0-1.51.42-2.96 1.21-4.33 3.55 6.22 14.56 10.76 27.59 10.76 13.03.01 24.04-4.53 27.59-10.76zm-.28 45.76c.96 1.51 1.49 3.12 1.49 4.8 0 8.34-12.9 15.1-28.8 15.1s-28.8-6.76-28.8-15.1c0-1.68.52-3.29 1.49-4.8 3.83 5.98 14.61 10.3 27.31 10.3s23.49-4.31 27.31-10.3zm.14-15.53c.88 1.45 1.35 2.98 1.35 4.58 0 8.34-12.9 15.1-28.8 15.1s-28.8-6.76-28.8-15.1c0-1.6.48-3.14 1.35-4.58 3.7 6.1 14.59 10.51 27.45 10.51s23.74-4.41 27.45-10.51z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)

export const TcsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 120.56 122.88"
        {...props}
    >
        <Path
            d="m55.75 47.8-2.56-11.73C61.64 37.65 74 51.24 81.85 62c-5.59 3.55-9 8.66-9 14.72a15.46 15.46 0 0 0 .21 2.57A36 36 0 0 0 61 77.26a34 34 0 0 0-15.54 3.54c-6.12 3.21-9.92 8.33-9.92 14.57a14.46 14.46 0 0 0 .87 5c-.11.32-.22.65-.31 1a14.12 14.12 0 0 0-.56 3.85 14.4 14.4 0 0 0 .83 4.85l-.22.68a14.31 14.31 0 0 0-.61 4 14.51 14.51 0 0 0 2.46 8.13h-.75c-11.88-.61-30.25-.59-35-12.78-7.79-19.72 6.4-43.16 19.34-57.51a70.92 70.92 0 0 1 5.28-5.27c4.71-4.14 9.79-9 15.84-11.1l-5.85 10.9 8.5-11.27h4.48l5.91 11.95Zm19.84 64.56a4.65 4.65 0 0 1 .7 2.41c0 4.44-6.87 8-15.34 8s-15.35-3.6-15.35-8a4.7 4.7 0 0 1 .7-2.41c2 3.27 7.78 5.64 14.65 5.64s12.7-2.37 14.64-5.64Zm44.11-2.86a5.71 5.71 0 0 1 .86 3c0 5.44-8.43 9.86-18.81 9.86S83 117.89 83 112.45a5.67 5.67 0 0 1 .86-3c2.39 4 9.52 6.91 17.94 6.91s15.56-2.91 18-6.91Zm0-11.92a5.76 5.76 0 0 1 .86 3c0 5.44-8.43 9.86-18.81 9.86S83 106 83 100.53a5.72 5.72 0 0 1 .86-3c2.39 4 9.52 6.91 17.94 6.91s15.56-2.91 18-6.91Zm-11.16-24.84-.22 2.45-9.22-.8a8.45 8.45 0 0 1 1.58 3.32l-2.22-.2a7.55 7.55 0 0 0-1-2.18 4.54 4.54 0 0 0-1.91-1.72l.17-2 12.83 1.11Zm-6.79-3.83c8.53 0 15.45 2.72 15.45 6.06S110.28 81 101.75 81 86.3 78.31 86.3 75s6.92-6.06 15.45-6.06Zm0-2c10.38 0 18.81 4.42 18.81 9.86s-8.43 9.86-18.81 9.86S83 82.2 83 76.76s8.42-9.86 18.8-9.86Zm18 19.11a5.69 5.69 0 0 1 .8 2.83c0 5.44-8.43 9.86-18.81 9.86S83 94.28 83 88.84a5.55 5.55 0 0 1 .74-2.84c2.32 4.06 9.5 7 18 7s15.69-3 18-7Zm-53.26 6.07-.18 2-7.53-.66a6.94 6.94 0 0 1 1.29 2.71L58.26 96a6 6 0 0 0-.82-1.78 3.78 3.78 0 0 0-1.56-1.4l.12-1.64 10.47.91ZM61 89c7 0 12.61 2.22 12.61 5S67.96 99 61 99s-12.61-2.22-12.61-5S54 89 61 89Zm0-1.64c8.47 0 15.34 3.61 15.34 8.05s-6.87 8-15.34 8-15.35-3.6-15.35-8 6.83-8.09 15.35-8.09Zm14.69 15.6a4.59 4.59 0 0 1 .65 2.31c0 4.43-6.87 8-15.34 8s-15.35-3.61-15.35-8a4.56 4.56 0 0 1 .65-2.31c1.89 3.31 7.75 5.73 14.7 5.73s12.8-2.42 14.69-5.73ZM42.34 20.3C40.52 14.93 38.88 9.5 37.5 4c5.16-5.66 25.1-4.91 30.83-.09L63 16.52c2.86-3.76 3.82-5.3 5.52-7.39a17.17 17.17 0 0 1 2 1.57c1.51 1.37 2.86 2.88 3.13 5a5.16 5.16 0 0 1-1.43 4.17L60.09 34.05a26.61 26.61 0 0 1-4.59-1.16c.69-1.63 1.53-3.42 2.22-5l-4.44 4.79a16.54 16.54 0 0 0-11.8 1.44L29.13 19.25a4.1 4.1 0 0 1-1.07-2.66c0-3.58 5.35-6.67 8.15-7.84l6.13 11.55Z"
            style={{
                fillRule: "evenodd",
            }}
        />
    </Svg>
)

export const ReportsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M96.865 0h830.27C980.632 0 1024 43.368 1024 96.865v830.27c0 53.497-43.368 96.865-96.865 96.865H96.865C43.368 1024 0 980.632 0 927.135V96.865C0 43.368 43.368 0 96.865 0zm355.923 188.084V842.89h153.254V188.084H452.788zM682.669 550.31v292.573h153.254V550.31H682.669zm-466.73-139.32v431.893h153.255V410.991H215.939z" />
    </Svg>
)

export const CompanyMasterComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: "1.0009765625em",
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1025 1024"
        {...props}
    >
        <Path
            fill="#CCC"
            d="M641.414 894.817c-64.356 23.845-125.266 50.238-193.092 63.659 17.74-24.625 34.312-47.127 50.155-70.133 2.593-3.766 3.995-10.484 2.512-14.605-27.373-76.15-55.267-152.111-83.074-228.107-.518-1.415-1.293-2.74-2.782-5.84-1.782 3.772-3.18 6.217-4.134 8.824-26.997 73.77-53.795 147.61-81.112 221.257-3.165 8.536-2.048 14.39 3.294 21.459 16.626 21.999 32.517 44.555 49.879 68.532-39.731-3.155-75.996-11.837-110.312-27.033-46.192-20.45-91.497-42.902-137.605-63.552-40.336-18.065-82.506-29.478-127.12-30.011-2.296-.028-4.585-.58-8.022-1.045 6.69-28.864 13.24-57.23 19.847-85.584 1.88-8.075 5.2-16.043 5.635-24.176 1.005-18.697 12.687-28.527 27.137-37.17 56.464-33.775 116.87-59.121 177.42-84.323 47.423-19.739 35.207-6.986 52.82-56.845 3.34-9.452 6.34-18.25 16.996-22.725 3.584-1.505 6.475-7.96 7.141-12.525 2.281-15.626 4.168-31.407 4.629-47.167.167-5.658-3.014-12.309-6.617-17.008-11.787-15.383-18.83-32.444-23.451-51.206-6.025-24.478-14.195-48.423-20.8-72.767-2.458-9.065-3.126-18.618-4.564-27.954-1.283-8.332.022-14.698 8.14-20.251 3.967-2.714 5.434-11.039 5.66-16.915.82-21.33 1.733-42.755.594-64.038-2.046-38.231 15.567-65.817 44.396-88.077 32.415-25.03 70.423-36.787 109.578-45.471 16.949-3.76 34.136-6.554 51.322-9.07 7.056-1.033 14.391-.17 21.598-.17.367 1.07.735 2.141 1.101 3.215-3.128 2.557-6.25 5.117-9.382 7.668-10.67 8.69-11.231 15.1-1.12 24.127 15.333 13.693 30.664 27.445 46.74 40.237 20.828 16.572 29.931 38.016 29.864 64.092-.065 24.912-.352 49.838.44 74.729.175 5.486 4.586 10.795 6.842 16.27 1.696 4.123 4.547 8.468 4.31 12.563-.915 15.77-2.19 31.589-4.741 47.158-1.1 6.705-6.147 12.662-8.511 19.28-6.637 18.568-12.783 37.313-19.192 55.962-1.278 3.726-2.089 7.958-4.426 10.923-19.96 25.306-16.94 54.924-16.132 84.116.095 3.414.62 8.377 2.833 9.916 15.24 10.62 17.505 27.878 21.78 43.42 5.052 18.367 16.406 28.595 33.91 32.16 12.169 2.478 24.843 3.973 37.184 3.43 5.897-.257 11.577-5.578 9.019-14.637-10.397-36.822.906-60.756 35.727-76.753 8.603-3.955 17.164-8.119 26.065-11.283 26.091-9.283 52.931.71 68.165 24.048 2.466 3.779 8.006 7.542 12.174 7.6 3.43.044 8.157-4.754 10.21-8.543 13.444-24.793 40.148-36.79 67.225-28.88 11.341 3.32 22.491 7.483 33.402 12.045 28.423 11.889 41.403 38.235 34.845 68.483-.824 3.8.041 9.942 2.566 11.988 3.07 2.493 9.198 3.394 13.192 2.22 29.561-8.696 57.09 2.458 70.856 29.875 5.483 10.924 10.77 22.04 14.945 33.505 9.264 25.434-.762 52.383-23.484 67.272-3.902 2.556-8.358 7.839-8.318 11.823.038 3.87 4.745 9.105 8.742 11.297 24.568 13.479 36.319 38.962 28.786 66.085-3.366 12.13-7.725 24.077-12.687 35.656-11.616 27.093-38.101 39.885-67.02 33.774-4.165-.877-10.523-.028-13.095 2.67-2.547 2.672-3.14 9.157-1.926 13.16 8.478 27.951-1.499 54.968-27.078 68.897-11.747 6.397-24.061 12.032-36.634 16.584-25.278 9.15-52.69-1.207-67.315-23.656-2.51-3.852-7.952-8.235-11.852-8.068-3.91.17-8.933 5-11.141 9.05-13.23 24.283-39.577 36.176-66.294 28.448-11.727-3.394-23.29-7.607-34.524-12.397-28.41-12.119-41.126-38.46-33.874-68.786.608-2.566.866-5.212 1.755-10.706zm277.818-266.215c-7.164-7.552-13.695-15.583-21.38-22.291-15.038-13.122-15.302-12.815-8.966-31.318.51-1.491 1.034-2.983 1.439-4.506 4.38-16.485-.986-29.17-16.29-36.058-9.689-4.36-19.794-7.984-30.002-10.942-15.112-4.385-29.942.52-34.055 15.28-6.01 21.57-18.503 23.783-38.301 24.73-17.731.844-26.913-1.438-33.44-18.72-6.302-16.699-20.657-21.897-36.834-15.798a203.205 203.205 0 0 0-32.922 15.97c-10.43 6.282-14.464 16.581-11.247 28.598 2.687 10.032 10.717 21.033 8.387 29.373-2.613 9.35-14.217 16.181-21.886 24.13-.82.851-1.667 1.751-2.21 2.782-4.483 8.495-10.184 9.49-19.314 5.917-29.652-11.61-40.614-5.501-52.555 23.765-13.866 33.99-8.223 50.04 26.423 59.97 3.008.864 6.202 6.327 6.617 9.963 1.026 8.982-1.18 18.559.962 27.13 3.415 13.652-.922 20.848-13.936 24.107-1.88.47-3.633 1.546-5.364 2.484-15.96 8.641-21.228 21.957-14.693 38.777a249.957 249.957 0 0 0 12.316 26.908c7.166 13.475 20.73 21.724 32.03 15.192 22.195-12.83 35.94-5.493 51.282 11.642 12.561 14.032 14.354 12.426 8.248 29.801-.654 1.858-1.411 3.69-1.922 5.588-4.458 16.555.788 29.038 16.333 35.947 10.407 4.627 21.272 8.536 32.287 11.399 14.015 3.638 27.325-.991 31.131-14.395 6.153-21.669 17.946-27.112 39.521-25.908 21.679 1.21 21.82-1.337 31.99 18.207 8.384 16.11 20.977 22.326 36.953 16.593 11.086-3.98 21.872-9.213 32.074-15.127 12.275-7.123 18.687-20.292 11.791-32.23-11.939-20.674-5.033-32.963 10.726-47.286 15.26-13.867 13.79-15.486 34.427-8.87 18.543 5.945 31.834.143 39.372-17.67 3.688-8.715 7.048-17.613 9.828-26.654 4.632-15.069.797-30.36-12.915-33.948-25.105-6.564-29.714-22.113-26.346-44.035a2.558 2.558 0 0 0-.085-1.178c-4.952-14.144.68-22.195 14.595-25.651 1.877-.463 3.635-1.543 5.342-2.524 15.23-8.748 20.027-21.706 13.564-38.214-3.449-8.808-7.453-17.442-11.824-25.832-8.618-16.537-22.413-21.534-39.714-14.638-6.91 2.75-13.609 6.033-21.437 9.54zm-504.213 8.96 27.302-58.359h-54.343l27.041 58.358z"
        />
        <Path
            fill="#CCC"
            d="M781.516 630.036c59.7.496 110.039 46.813 110.101 110.055.062 63.638-50.636 112.69-112.345 111.5-59.13-1.143-108.882-46.983-108.892-110.08-.008-63.427 50.406-112.455 111.136-111.475zm.174 28.95c-46.286.068-82.435 36.223-82.636 82.655-.19 43.491 37.05 81.022 80.635 81.267 46.148.262 83.704-37.4 83.34-83.564-.347-43.845-37.372-80.426-81.34-80.359z"
        />
    </Svg>
)

export const DepartmentsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#000"
            d="M912.384 659.73h-56.047l-6.212-6.247v-71.476c0-23.586-19.456-42.837-43.35-42.837h-273.34l-6.246-6.246v-92.911l6.247-6.28H618.7c23.893 0 43.35-19.252 43.35-42.804V179.371c0-23.62-19.457-42.838-43.35-42.838H405.299c-23.927 0-43.35 19.252-43.35 42.838v211.558c0 23.552 19.423 42.803 43.35 42.803h85.231l6.247 6.28v92.912l-6.247 6.246H217.225c-23.928 0-43.35 19.251-43.35 42.837v71.476l-6.246 6.246h-56.013c-23.927 0-43.35 19.251-43.35 42.837v153.6c0 23.587 19.423 42.838 43.35 42.838h154.931c23.894 0 43.35-19.251 43.35-42.838v-153.6c0-23.586-19.456-42.837-43.35-42.837h-56.013l-6.246-6.246v-78.166l6.246-6.246H490.53l6.247 6.246v78.166l-6.247 6.246h-56.013c-23.893 0-43.349 19.251-43.349 42.837v153.6c0 23.587 19.456 42.838 43.35 42.838h154.965c23.893 0 43.315-19.251 43.315-42.838v-153.6c0-23.586-19.422-42.837-43.315-42.837h-56.047l-6.247-6.246v-78.166l6.247-6.246h280.03l6.246 6.246v78.166l-6.246 6.246h-56.047c-23.894 0-43.316 19.251-43.316 42.837v153.6c0 23.587 19.422 42.838 43.316 42.838h154.965c23.893 0 43.35-19.251 43.35-42.838v-153.6c0-23.586-19.457-42.837-43.35-42.837zm-505.48-270.44h210.124V180.976H406.903V389.29zm-293.65 465.238H264.91V704.205H113.254v150.323zm322.902 0H587.81V704.205H436.156v150.323zm322.935 0h151.655V704.205H759.09v150.323z"
        />
    </Svg>
)

export const DesignationComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="M853.333 298.667h-128v-85.334A85.333 85.333 0 0 0 640 128H384a85.333 85.333 0 0 0-85.333 85.333v85.334h-128A85.333 85.333 0 0 0 85.333 384v426.667A85.333 85.333 0 0 0 170.667 896h682.666a85.333 85.333 0 0 0 85.334-85.333V384a85.333 85.333 0 0 0-85.334-85.333zm-256 298.666A42.667 42.667 0 0 1 554.667 640h-85.334a42.667 42.667 0 0 1-42.666-42.667V576A21.333 21.333 0 0 1 448 554.667h128A21.333 21.333 0 0 1 597.333 576zM640 298.667H384v-85.334h256z" />
    </Svg>
)

export const LocationComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path
            fill="#030000"
            d="M787.7 339.7C787.7 187.4 664.3 64 512 64c-152.3 0-275.7 123.4-275.7 275.7 0 50.3 13.7 97.2 37.2 137.8h-.3L512 960l238.9-482.5h-.3c23.5-40.6 37.1-87.5 37.1-137.8M512 477.5c-76.1 0-137.8-61.7-137.8-137.8 0-76.1 61.7-137.8 137.8-137.8 76.2 0 137.8 61.8 137.8 137.8.1 76.1-61.6 137.8-137.8 137.8"
        />
    </Svg>
)

export const RolesPermissionsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 48,
            height: 36,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
        {...props}
    >
        <Path d="m526.911 0 407.232 148.608c15.488 4.736 25.984 19.136 25.856 35.328v274.688c0 326.848-355.968 470.4-443.136 514.944a36.16 36.16 0 0 1-32.448 0C397.055 929.024 64 787.008 64 460.608V184.96a37.76 37.76 0 0 1 25.024-35.2L502.08 0h24.832zM512 244.352a122.176 122.176 0 0 0-40.192 237.632 37.248 37.248 0 0 0-.576 6.784v203.52a40.704 40.704 0 1 0 81.472 0v-203.52a35.84 35.84 0 0 0-.64-6.784A122.24 122.24 0 0 0 512 244.352z" />
    </Svg>
)

export const SalesDashboardComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M829.06 73.14h-6.48c-30.41 0-58.57 17.11-75.34 45.75-6.12 10.46-22.29 11.71-29.96 2.43-25.52-31.07-59.41-48.18-95.64-48.18-35.98 0-69.86 17.11-95.41 48.18-6.98 8.5-21.25 8.52-28.27-.02-25.55-31.05-59.43-48.16-95.41-48.16s-69.86 17.11-95.41 48.18c-7.66 9.36-23.82 8.05-29.95-2.43-16.8-28.64-44.96-45.75-75.36-45.75h-7.23c-46.89 0-85.05 38.16-85.05 85.05V865.8c0 46.89 38.16 85.05 85.05 85.05h7.23c30.39 0 58.55-17.11 75.38-45.79 6.07-10.45 22.23-11.79 29.93-2.38 25.55 31.05 59.43 48.16 95.41 48.16s69.86-17.11 95.41-48.18c7.02-8.52 21.29-8.5 28.27.02 25.55 31.05 59.43 48.16 95.66 48.16 35.98 0 69.88-17.11 95.38-48.14 7.73-9.36 23.89-8 29.96 2.36 16.79 28.68 44.95 45.79 75.36 45.79h6.48c46.89 0 85.05-38.16 85.05-85.05V158.2c0-46.9-38.17-85.06-85.06-85.06zm11.91 792.66c0 6.57-5.34 11.91-11.91 11.91h-6.48c-6.14 0-10.91-7.34-12.23-9.61-16.36-27.91-46.61-45.25-78.93-45.25-27.43 0-53.16 12.16-70.64 33.39-6.59 8.02-20.41 21.46-39.14 21.46-18.48 0-32.32-13.46-38.91-21.46-34.84-42.45-106.39-42.46-141.27-.02-6.59 8.02-20.43 21.48-38.91 21.48-18.48 0-32.32-13.46-38.91-21.46-17.43-21.23-43.18-33.39-70.62-33.39-32.36 0-62.61 17.36-78.93 45.25-1.32 2.25-6.11 9.61-12.25 9.61h-7.23c-6.57 0-11.91-5.34-11.91-11.91V158.2c0-6.57 5.34-11.91 11.91-11.91h7.23c6.14 0 10.93 7.36 12.23 9.57 16.34 27.93 46.59 45.29 78.95 45.29 27.45 0 53.2-12.16 70.62-33.38 6.59-8.02 20.43-21.48 38.91-21.48 18.48 0 32.32 13.46 38.91 21.46 34.88 42.48 106.43 42.43 141.27.02 6.59-8.02 20.43-21.48 39.16-21.48 18.48 0 32.3 13.45 38.91 21.5 17.46 21.2 43.2 33.36 70.62 33.36 32.32 0 62.57-17.34 78.95-45.29 1.3-2.23 6.07-9.57 12.21-9.57h6.48c6.57 0 11.91 5.34 11.91 11.91v707.6z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M255.93 548.66h365.71v73.14H255.93zm-.01 146.27h511.82v73.14H255.92zm365.62-365.7h58l-83.85 83.86 51.71 51.71 83.86-83.85v58h73.14V256.09H621.54z"
        />
    </Svg>
)


export const CashInComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M494.54 620.708q-27.033-13.517-43.939-30.413l-5.632-2.253q-7.885-4.505-14.643-4.505-6.759 0-12.954 2.816t-8.448 7.321q-10.137 10.138-10.137 20.275 0 7.885 2.816 13.517t10.7 13.517q27.034 24.791 61.963 41.687 38.297 12.39 70.963 16.896v78.858h65.341v-85.616q59.71-11.264 92.375-43.94 37.171-39.424 37.171-82.227 0-60.836-30.412-85.617-27.034-27.044-95.755-43.94v-144.19q27.034 6.76 40.55 13.518 24.792 14.643 31.55 21.401 6.759 6.759 16.896 6.759 5.632 0 11.827-2.816 6.196-2.816 8.448-7.322 10.138-10.138 10.138-21.402 0-15.77-16.896-27.033-27.034-20.286-45.056-27.044-31.55-12.39-57.457-16.896v-68.71h-68.72v65.33q-56.32 4.506-99.134 40.561-37.17 37.172-37.17 85.607 0 55.204 34.365 84.49 34.365 29.297 101.949 45.066v149.822q-33.792-6.759-50.688-13.517zm116.03-119.409q30.413 10.138 47.309 27.034 18.033 20.275 18.033 41.687 0 19.149-18.033 37.171-10.138 10.138-43.93 23.654V501.3h-3.379zM491.162 395.407q-16.896-16.896-16.896-40.56 0-23.655 16.896-40.55 15.77-13.517 50.688-24.781v134.051l-20.276-10.137q-21.401-11.264-30.412-18.023zM139.684 573.4l47.319 47.309L313.17 494.54l24.78-23.655-24.78-23.664-126.167-126.167-47.32 47.319 67.595 68.71H0v67.594h207.278L139.684 573.4zM1024 447.222v-23.655q0-4.505-1.69-12.953t-1.69-11.827-1.689-11.828-1.69-11.827q0-5.632-6.758-20.285l-1.126-3.38q-11.264-40.55-23.655-68.71l-30.423-60.836q-6.758-13.517-13.516-20.275-3.38-7.885-13.517-18.022v-3.38q-6.759-3.379-13.517-16.896-3.38-6.758-13.517-16.906-7.885-3.379-21.401-16.896l-10.148-10.137-2.253-3.38q-2.253-3.379-4.506-3.379l-11.264-9.011q-9.01-5.632-12.39-7.885l-6.758-5.632q-4.506-3.379-6.759-4.505-5.632-7.885-10.137-7.885-15.77-15.77-31.54-20.275-13.516-9.022-27.044-13.527h-1.126q-2.253-1.127-2.253-3.38L738.99 33.23q-10.138-5.069-15.77-6.195-20.275-6.759-33.792-10.138h-3.379q-20.275-6.758-31.55-6.758h-3.378q-4.506-2.253-14.644-3.943t-15.77-2.816h-6.758q-3.379 0-11.827-1.69T590.295 0h-72.1Q501.3 0 494.541 3.38q-4.506 0-16.333 1.689-11.827 1.69-17.47 1.69-11.263 0-24.78 6.758-3.38 1.126-11.827 2.816t-11.828 3.379q-3.379 1.69-10.137 3.38-6.759 1.689-10.138 3.942h-3.379l-31.55 10.137q-2.252 1.127-2.252 3.38-4.506 1.126-15.207 6.195-10.7 5.068-16.332 7.331h-3.38l-5.632 2.253q-12.39 5.632-18.022 11.264-15.77 3.38-33.792 18.023-1.126 1.126-6.206 4.505-5.068 3.38-7.321 5.632L228.68 116.03q-11.264 6.759-24.781 20.276l-3.38 3.379q-16.895 16.906-23.654 27.044l-6.758 6.758v3.38q-3.38 3.378-9.011 11.263l-7.895 10.138 54.077 40.55q6.758-6.758 13.517-20.275l4.505-3.38q2.253-2.252 5.632-7.32t4.506-6.196q23.665-29.286 54.078-55.204 2.252-2.253 7.321-5.632t7.322-5.069l9.01-6.758q6.76-5.069 10.139-6.195l7.884-4.506q5.632-3.379 10.138-5.632h2.253q1.126-1.126 1.126-3.379l20.286-10.138q3.379 0 10.137-1.69 6.759-1.689 10.138-1.689l27.033-10.137q33.792-13.517 68.721-18.023 3.38 0 11.827-1.69t11.827-1.689h43.93-6.758 51.824q5.632 0 15.77 1.69t14.643 1.69q10.138 0 14.643 2.252t14.643 3.942q10.138 1.69 14.654 3.943h1.126q16.896 7.885 23.655 7.885 2.252 0 5.632 1.69t4.505 1.689q27.034 11.264 54.067 27.033 13.528 6.759 20.286 13.517 2.253 0 4.506 3.38l2.252 3.379q7.885 3.379 21.402 16.896h2.253q1.126 1.136 1.126 3.39 3.38 3.378 11.827 10.137 8.448 6.758 11.828 10.137 13.516 13.517 20.275 21.402 2.253 3.38 7.321 8.448t6.759 7.321q1.69 2.253 5.069 7.322 3.389 5.069 4.515 7.322l-3.379-3.38q2.253 3.38 7.322 10.138l6.758 9.011q1.69 2.253 3.38 5.632l2.815 5.632L904.591 276q4.506 6.758 10.138 20.275l5.632 12.39q5.632 11.264 7.885 19.15 0 1.126 1.69 5.068t2.815 7.885q1.127 3.942 2.816 10.7t2.816 10.148q0 6.759 3.38 6.759 2.252 3.379 3.942 11.827t2.816 11.827v6.759q0 4.505 1.69 13.516 1.69 9.012 1.69 14.644v74.352q0 4.506-1.69 14.643t-1.69 15.77q0 14.643-6.758 28.16-6.759 20.285-6.759 30.423-10.137 29.286-23.654 58.573l-31.54 54.077q-3.379 4.506-10.147 12.954t-10.138 12.953-10.137 12.954q-6.759 8.448-10.138 11.827-11.264 13.517-23.654 21.412-13.517 13.517-23.655 16.896-11.264 6.759-31.55 20.275-13.516 6.759-20.275 13.517h-3.379q-1.126 1.127-4.505 2.816-3.38 1.69-5.632 3.943l-4.506 2.252q-7.885 4.506-12.39 4.506-7.885 5.632-28.16 11.264l-37.182 12.39q-4.505 0-11.264 3.38-4.505 1.126-6.758 1.126t-9.011 1.69q-6.759 1.69-10.138 1.69-3.38 0-11.827 1.689t-12.39 1.69q-3.943 0-16.333 1.689-12.401 1.69-18.033 1.69-33.792 0-50.688-3.38h-3.38q-10.137 0-16.895-3.379-3.38 0-11.838-1.69-8.448-1.69-11.837-1.69-6.758-2.252-16.896-4.505l-11.264-3.379h-3.38q-3.378-2.253-10.137-3.942-6.758-1.69-10.137-2.816l-16.896-6.759q-23.655-9.01-47.32-23.654-2.252-2.253-7.884-3.38l-6.759-3.378q-40.55-27.034-60.825-47.31-6.769-6.768-10.148-11.274l-13.517-13.516q2.253 0 1.126-1.127t-1.126-2.253q-6.758-6.758-18.022-23.654l-54.068 40.55q0 2.253 1.69 4.506t1.69 3.38q3.379 3.389 10.137 11.837 6.759 8.448 10.138 11.827 3.379 3.38 10.137 11.827 6.759 8.448 10.138 11.827 6.758 6.759 10.138 6.759 7.884 6.758 18.022 16.896l3.38 2.253q3.378 2.252 3.378 4.505 5.632 3.38 14.08 10.138t12.964 10.137q10.138 7.895 30.413 21.412t34.918 16.896q7.885 5.632 28.17 11.264l5.633 2.253 33.792 13.517h3.379q20.275 6.758 30.413 6.758l14.08 2.816q8.448 1.69 14.08 3.943 3.379 0 8.448 1.69t9.574 1.689q4.506 0 12.954 1.69t12.953 1.689h72.1q13.517 0 20.275-3.38 13.517 0 20.276-2.252 6.758-2.253 19.148-3.942t18.023-3.943q25.917-5.632 38.308-10.137h3.379l27.033-10.138q2.253 0 5.632-1.69t4.506-1.69l5.632-2.252q12.39-5.632 18.022-11.264 7.895-2.253 25.918-13.517l22.528-13.517q13.517-7.895 33.792-28.17 27.044-20.275 37.181-33.792l10.138-10.137q11.264-10.138 24.78-30.413l4.506-5.643q4.506-7.884 9.011-12.39 0-2.253 1.69-3.942t1.69-2.816l3.379-3.38v-3.379q16.896-27.033 43.94-81.11 2.253-3.38 3.942-9.012 1.69-5.632 2.816-9.011 7.885-15.77 13.517-43.93 0-4.505 2.253-11.264l1.126-5.632q0-3.379 1.69-8.448t1.69-8.458q11.263-45.056 11.263-92.365v-6.768q3.38-3.38 3.38-13.517z"
        />
    </Svg>
)

export const CashOutComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M545.229 0q-113.777 0-212.91 49.562-96.88 48.445-162.212 134.062L225.3 225.3q54.078-73.226 139.121-115.466 85.054-42.24 180.808-42.24 110.397 0 206.151 56.32 93.502 54.078 147.58 147.58 56.32 95.753 56.32 206.15 0 110.398-56.32 206.152-54.078 93.502-147.58 147.57-95.754 56.33-206.151 56.33-95.754 0-182.487-42.814-84.49-41.677-141.947-114.903l-50.688 41.687q67.584 85.606 164.465 134.052 100.26 49.561 210.657 49.561 129.556 0 241.08-65.33 108.145-64.216 172.35-172.36Q1024 607.19 1024 477.644q0-129.557-65.341-239.954-64.205-108.145-172.35-172.35Q674.785 0 545.23 0zM494.54 627.466q-27.034-13.517-43.94-30.413l-5.632-2.252q-7.885-4.506-14.643-4.506-6.759 0-12.954 2.816t-8.448 7.322q-10.137 10.137-10.137 20.275 0 7.885 2.816 13.517t10.7 13.516q27.034 24.791 61.963 41.687 38.297 12.39 70.963 16.896v78.859h65.341v-85.617q59.71-11.264 92.375-43.94 37.171-39.424 37.171-82.227 0-60.836-30.412-85.617-27.034-27.043-95.755-43.94V299.654q27.034 6.759 40.55 13.517 24.792 14.643 31.55 21.402 6.759 6.758 16.896 6.758 5.632 0 11.827-2.816 6.196-2.816 8.448-7.322 10.138-10.137 10.138-21.401 0-15.77-16.896-27.034-27.034-20.275-45.056-27.044-31.55-12.39-57.457-16.896v-68.71h-68.72v65.331q-56.32 4.506-99.134 40.56-37.17 37.172-37.17 85.617 0 55.194 34.365 84.48 34.365 29.297 101.949 45.056v149.822q-33.792-6.759-50.688-13.517zm116.03-119.408q30.412 10.137 47.308 27.033 18.033 20.275 18.033 41.687 0 19.149-18.033 37.171-10.138 10.138-43.93 23.655V508.058h-3.379zM491.16 402.166q-16.895-16.896-16.895-40.56t16.896-40.562q15.77-13.516 50.688-24.78v134.052l-20.276-10.138q-21.401-11.264-30.412-18.022zm-361.615 109.27h208.405v-67.593H129.546l67.594-68.71-47.319-47.32L0 477.645l149.821 149.821 47.32-47.309-67.595-68.72z"
        />
    </Svg>
)

export const AssetsComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: props.color ?? "white",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path d="m946.688 382.464-270.848-66.56c-6.656-1.536-13.312-2.048-19.456-1.024V98.816c14.336-11.776 22.528-30.72 19.456-50.176-4.608-29.696-32.256-49.664-61.952-45.056L98.816 82.944C69.12 87.552 49.152 115.2 53.248 144.896c2.048 13.824 9.728 25.6 19.456 33.792v809.984c0 18.944 15.36 33.792 33.792 33.792H926.72c18.944 0 33.792-15.36 33.792-33.792V481.28c11.776-7.168 21.504-18.944 25.088-33.28 8.192-29.184-9.728-58.368-38.912-65.536zm-529.92 552.96h-104.96V765.44H417.28v169.984zm.512-247.808H312.32v-102.4h105.472v102.4zm0-185.344H312.32V399.36h105.472v102.912zm0-185.856H312.32v-102.4h105.472v102.4zm388.608 619.008h-61.952v-87.04h61.952v87.04zm.512-133.12h-62.464v-60.928H806.4v60.928zm0-110.08h-62.464v-60.928H806.4v60.928zm0-110.08h-62.464v-60.928H806.4v60.928zm0 0" />
    </Svg>
)

export const LiabilityComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M613.888 241.152c0-18.944-15.36-34.816-34.816-34.816H183.808c-18.944 0-34.816 15.36-34.816 34.816 0 18.944 15.36 34.816 34.816 34.816h395.264c19.456 0 34.816-15.872 34.816-34.816z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M443.392 926.72H114.688c-18.944 0-34.816-15.36-34.816-34.816V132.096c0-18.944 15.36-34.816 34.816-34.816H701.44c18.944 0 34.816 15.36 34.816 34.816h69.12c0-7.168-.512-13.824-1.536-20.48C794.112 64 752.64 28.16 702.464 28.16H114.688C57.344 29.184 11.264 74.752 11.264 132.096v759.808c0 57.344 46.592 103.936 103.936 103.936h328.704c18.944 0 34.816-15.36 34.816-34.816-.512-18.944-16.384-34.304-35.328-34.304z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M736.256 132.096V304.64c0 18.944 15.36 34.816 34.816 34.816s34.816-15.36 34.816-34.816V132.096m-91.136 266.24c-164.352 0-297.984 133.632-297.984 297.984s134.144 297.984 297.984 297.984c164.352 0 297.984-133.632 297.984-297.984 0-164.864-133.12-297.984-297.984-297.984zm0 530.432c-128 0-232.448-104.448-232.448-232.448s104.448-232.448 232.448-232.448S947.2 567.808 947.2 696.32 842.752 928.768 714.752 928.768zM183.808 384c-18.944 0-34.816 15.36-34.816 34.816s15.36 34.816 34.816 34.816h241.664c18.944 0 34.816-15.36 34.816-34.816S444.928 384 425.472 384H183.808z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M714.752 666.112c-17.408 0-31.744-14.336-31.744-31.744 0-8.192 3.072-15.872 8.704-22.016 6.144-6.144 13.824-8.704 22.016-8.704 8.192 0 15.872 3.072 22.016 8.704 6.144 6.144 8.704 13.824 8.704 22.016 0 17.92 14.336 32.256 32.256 32.256s32.256-14.336 32.256-32.256c0-41.984-26.624-77.312-65.536-90.624V529.92c0-17.92-14.336-32.256-32.256-32.256S678.912 512 678.912 529.92v15.872c-41.984 15.872-66.56 58.368-59.392 103.424 7.168 47.104 46.592 80.896 94.208 80.896 17.408 0 31.232 13.824 31.744 31.232 0 8.192-3.072 15.872-8.704 22.016-6.144 6.144-13.824 9.728-22.016 9.728h-.512c-17.408 0-31.232-14.336-31.232-31.744 0-17.92-14.336-32.256-32.256-32.256s-32.256 14.336-32.256 32.256c0 39.936 24.576 74.752 60.928 89.088v13.312c0 17.92 14.336 32.256 32.256 32.256s32.256-14.336 32.256-32.256V852.48c43.008-13.824 70.144-56.832 65.024-101.888-5.12-48.128-46.08-84.48-94.208-84.48z"
        />
    </Svg>
)

export const NetProfitComponentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon"
        style={{
            width: 40,
            height: 40,
            verticalAlign: "middle",
            fill: "currentColor",
            overflow: "hidden",
        }}
        viewBox="0 0 1024 1024"
    >
        <Path
            fill={props.color ?? "white"}
            d="M325.818 930.91v-93.091H139.636v93.09h186.182zM139.636 744.727h186.182a93.09 93.09 0 0 1 93.09 93.09v139.637A46.545 46.545 0 0 1 372.363 1024H139.636a93.09 93.09 0 0 1-93.09-93.09v-93.091a93.09 93.09 0 0 1 93.09-93.091z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M605.09 930.91V651.636H418.908V930.91H605.09zM418.908 558.546H605.09a93.09 93.09 0 0 1 93.09 93.09v325.818A46.545 46.545 0 0 1 651.635 1024H372.363a46.545 46.545 0 0 1-46.545-46.545V651.637a93.09 93.09 0 0 1 93.09-93.09z"
        />
        <Path
            fill={props.color ?? "white"}
            d="M698.18 930.91h186.182v-46.546a46.545 46.545 0 0 1 93.09 0v46.545a93.09 93.09 0 0 1-93.09 93.091H651.635a46.545 46.545 0 0 1-46.545-46.545v-512a93.09 93.09 0 0 1 93.09-93.09h186.182a93.09 93.09 0 0 1 93.09 93.09v232.728a46.545 46.545 0 0 1-93.09 0V465.456H698.18v465.453zM168.727 501.76a46.545 46.545 0 0 1-58.182-72.61L575.208 56.787a46.545 46.545 0 1 1 58.181 72.61L168.727 501.761z"
        />
        <Path
            fill={props.color ?? "white"}
            d="m605.09 93.977-93.557-.884a46.545 46.545 0 0 1 .931-93.09L652.1 1.305a46.545 46.545 0 0 1 46.08 46.545v138.333a46.545 46.545 0 0 1-93.09 0V93.977z"
        />
    </Svg>
)